export const shapeEndpoints = {
  LIST: (orgId: string, projectId: string) =>
    `/api/organizations/${orgId}/projects/${projectId}/shapes/`,
  CREATE: (orgId: string, projectId: string) =>
    `/api/organizations/${orgId}/projects/${projectId}/shapes/`,
  DETAIL: (orgId: string, projectId: string, shapeId: string) =>
    `/api/organizations/${orgId}/projects/${projectId}/shapes/${shapeId}/`,
  UPDATE: (orgId: string, projectId: string, shapeId: string) =>
    `/api/organizations/${orgId}/projects/${projectId}/shapes/${shapeId}/`,
  DELETE: (orgId: string, projectId: string, shapeId: string) =>
    `/api/organizations/${orgId}/projects/${projectId}/shapes/${shapeId}/`,
  REFRESH: (orgId: string, projectId: string, shapeId: string) =>
    `/api/organizations/${orgId}/projects/${projectId}/shapes/${shapeId}/refresh/`,
  LOCATION_AREAS: (orgId: string, projectId: string, codes: string[]) =>
    `/api/organizations/${orgId}/projects/${projectId}/shapes/location-areas/?codes=${codes.map((c) => encodeURIComponent(c)).join(',')}`,
};
